import React, { Component } from 'react'
import { Link, withRouter } from 'react-router'
import { observer, inject } from 'mobx-react'
import DropdownMenu from './DropdownMenu'
import classnames from 'classnames'
import WelcomeProgress from '../sections/website/Welcome/progress'

@withRouter
@inject('welcome', 'auth')
@observer
class MenuWebsite extends Component {

  settingsDropdownClass() {
    const { router } = this.props
    return classnames('website-nav', {
      'active': router.location.pathname.match(/website\/\d+\/settings\/*/)
    })
  }

  recommendDropdownClass() {
    const { router } = this.props
    return classnames('website-nav', {
      'active': router.location.pathname.match(/website\/\d+\/recommended\/*/)
    })
  }

  render() {
    const { website, welcome } = this.props
    const { admin } = this.props.auth.user

    return (
      <div className="menu secondary website">
        <div className="name">
          {website.logo && <img src={website.logo} />}
          {website.name}
        </div>
        {welcome.progress < 1 && admin ? (
          <Link to={`/website/${website.id}/welcome`} activeClassName="active">
            Welcome
            <WelcomeProgress />
          </Link>
        ) : null }
        <Link to={`/website/${website.id}/leads`} activeClassName="active">Leads</Link>
        <Link to={`/website/${website.id}/messages`} activeClassName="active">Messages</Link>
        { admin ? <Link to={`/website/${website.id}/hotsheets`} activeClassName="active">Hotsheets</Link> : '' }
        <DropdownMenu menuClass={this.recommendDropdownClass()} menuTitle="Recommendations">
          <Link to={`/website/${website.id}/recommended/searches`}>Searches</Link>
          <Link to={`/website/${website.id}/recommended/listings`}>Listings</Link>
        </DropdownMenu>
        <Link to={`/website/${website.id}/searches`} activeClassName="active">Search Library</Link>
        { admin ? <DropdownMenu menuClass={this.settingsDropdownClass()} menuTitle="Settings">
          <Link to={`/website/${website.id}/settings/general`}>General</Link>
          <Link to={`/website/${website.id}/settings/privacy`}>Privacy</Link>
          <Link to={`/website/${website.id}/settings/email`}>Email</Link>
          <Link to={`/website/${website.id}/settings/search`}>Search</Link>
          <Link to={`/website/${website.id}/settings/registration`}>Registration</Link>
          <Link to={`/website/${website.id}/settings/seo`}>SEO</Link>
          <Link to={`/website/${website.id}/settings/design`}>Design</Link>
          <Link to={`/website/${website.id}/settings/display`}>Display</Link>
          <Link to={`/website/${website.id}/settings/lead-routing`}>Lead Routing</Link>
          <Link to={`/website/${website.id}/shortcodes`}>Shortcodes</Link>
          <Link to={`/website/${website.id}/welcome`}>Welcome Screen</Link>
        </DropdownMenu> : '' }
        <DropdownMenu menuClass="website-nav" menuTitle="Resources">
          <a href="https://support.showcaseidx.com/hc/en-us" target="_blank">Support Center</a>
          <a href="https://showcaseidx.com/live-demo/" target="_blank">Join a Live Demo</a>
          <a href="https://showcaseidx.com/custom-wordpress-real-estate-websites/" target="_blank">Approved Web Developers</a>
          <a href="https://showcaseidx.com/affiliates/" target="_blank">Join the Affiliate Program</a>
          <a href="https://changelog.showcaseidx.com/" target="_blank">Changelog</a>
        </DropdownMenu>
      </div>
    )
  }
}

export default MenuWebsite



// WEBPACK FOOTER //
// client/components/navigation/MenuWebsite.js